import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { AcsButton, AcsCard, AcsLogo, AcsPageShell, AcsStatusBadge } from '../components';
import './events.css';
import { LanguageSwitcher } from '../components/LanguageSwitcher';
import { useAuth } from '../auth/AuthProvider';
import { useI18n } from '../i18n/I18nProvider';
import { api } from '../api/client';

/** Elenco delle fiere configurate (§19). */
export function EventsPage() {
  const auth = useAuth();
  const { t } = useI18n();

  const events = useQuery({ queryKey: ['events'], queryFn: api.listEvents });

  return (
    <AcsPageShell
      header={
        <>
          <AcsLogo />
          <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--acs-space-4)' }}>
            <LanguageSwitcher />
            <AcsButton variant="secondary" onClick={() => void auth.logout()}>
              {t.app.logout}
            </AcsButton>
          </div>
        </>
      }
    >
      <h1 style={{ fontSize: 'var(--acs-font-size-xl)' }}>{t.app.events}</h1>

      <div
        style={{
          display: 'flex',
          gap: 'var(--acs-space-3)',
          flexWrap: 'wrap',
          marginBottom: 'var(--acs-space-5)',
        }}
      >
        <Link to="/app/events/new" className="acs-button acs-button--primary">
          {t.app.newEvent}
        </Link>
        <Link to="/app/policies" className="acs-button acs-button--secondary">
          {t.app.policies}
        </Link>
        <Link to="/app/audit" className="acs-button acs-button--secondary">
          {t.app.audit}
        </Link>
        {/*
          Gli utenti si gestiscono solo da ADMIN. Il divieto è del server — un
          OPERATOR riceve 403 su /api/users — qui si evita di mostrare un
          comando che porterebbe a un errore.
        */}
        {auth.status === 'authenticated' && auth.user.role === 'ADMIN' ? (
          <Link to="/app/users" className="acs-button acs-button--secondary">
            {t.app.users}
          </Link>
        ) : null}
        <Link to="/app/account" className="acs-button acs-button--secondary">
          {t.app.account}
        </Link>
      </div>

      {events.isLoading ? <p>{t.common.loading}</p> : null}
      {events.isError ? <p role="alert">{t.errors.unexpected}</p> : null}

      {events.data?.events.length === 0 ? <p>{t.app.noEvents}</p> : null}

      <div className="acs-stack">
        {events.data?.events.map((event) => (
          /*
           * La card è un link, non un div con un handler: si apre in una nuova
           * scheda con il tasto centrale, è raggiungibile da tastiera e viene
           * annunciata come link dagli screen reader (§20.6).
           */
          <Link key={event.id} to={`/app/events/${event.id}`} className="event-card">
            <AcsCard>
              <div className="event-card__row">
                <div>
                  <h2 className="event-card__name">{event.name}</h2>
                  <p className="event-card__meta">
                    {new Date(event.startsAt).toLocaleDateString()} —{' '}
                    {new Date(event.endsAt).toLocaleDateString()}
                    {event.location ? ` · ${event.location}` : ''}
                  </p>
                  <p className="event-card__meta">{event.languages.join(', ').toUpperCase()}</p>
                </div>
                <AcsStatusBadge>{t.app.eventStatus[event.status]}</AcsStatusBadge>
              </div>
            </AcsCard>
          </Link>
        ))}
      </div>
    </AcsPageShell>
  );
}
